import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "cardBack"
};
const _hoisted_2 = {
  class: "relations-container"
};
const _hoisted_3 = {
  key: 0,
  class: "pagination-container"
};
import { computed, onMounted, ref } from 'vue';
import { ElButton, ElMessage, ElPagination } from 'element-plus';
import { request } from '@/manager/net_manager';
import store from '@/store';
import { inApostleType } from '@/tools/utils';
import MaskerLayer from '@/components/Basic/MaskerLayer.vue';
import WORWORelationsCard from '@/components/WOOrganizations/WORWORelationsCard.vue';
import WORWORelationsEditCard from '@/components/WOOrganizations/WORWORelationsEditCard.vue'; // refs

export default {
  __name: 'WORolesWithOrganizations',

  setup(__props) {
    const relation = ref(null);
    const relations = ref([]);
    const pagerCount = ref(5);
    const size = ref(10);
    const total = ref(0);
    const page = ref(0); // computed

    const userType = computed(() => {
      return store.state.user ? parseInt(store.state.user.user_type) : 4;
    });
    const worldOutlook = computed(() => {
      return store.state.world_outlook ? store.state.world_outlook : null;
    }); // functions

    const getData = () => {
      let parameters = {
        'page': page.value,
        'size': size.value,
        'world_outlook_id': worldOutlook.value.id
      };
      request('wo_organizations/relations/get/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code === 0) {
          relations.value = response.data.relations;
          total.value = response.data.numbers;
        }
      });
    };

    const handlePageChange = index => {
      page.value = index - 1;
      getData();
    };

    const insertRelations = () => {
      relation.value = {
        'role': {},
        'organization': {},
        'skills_degree_license': 4,
        'position_held': '',
        'is_core': false,
        'is_active': true
      };
    };

    const editRelations = item => {
      relation.value = item;
    };

    const createRelations = item => {
      let parameters = { ...item,
        'world_outlook_id': worldOutlook.value.id
      };
      request('wo_organizations/relations/create/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        relation.value = null;
        getData();
      });
    };

    const updateRelations = item => {
      let parameters = { ...item,
        'world_outlook_id': worldOutlook.value.id
      };
      request('wo_organizations/relations/update/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        relation.value = null;
        getData();
      });
    };

    const removeRelations = item => {
      let parameters = { ...item,
        'world_outlook_id': worldOutlook.value.id
      };
      request('wo_organizations/relations/remove/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        relation.value = null;
        getData();
      });
    }; // lifecycle


    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_el_row = _resolveComponent("el-row");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createVNode(_component_el_row, {
        style: {
          "justify-content": "flex-end"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElButton), {
          onClick: insertRelations
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("新增角色组织关系", -1)]))]),
          _: 1
        })]),
        _: 1
      }, 512), [[_vShow, _unref(inApostleType)(userType.value)]]), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relations.value, item => {
        return _openBlock(), _createBlock(WORWORelationsCard, {
          key: item.id,
          relation: item,
          onEditRelations: editRelations
        }, null, 8, ["relation"]);
      }), 128))]), total.value > size.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_unref(ElPagination), {
        "page-size": size.value,
        "pager-count": pagerCount.value,
        layout: "prev, pager, next",
        total: total.value,
        background: true,
        onChange: handlePageChange
      }, null, 8, ["page-size", "pager-count", "total"])])) : _createCommentVNode("", true), relation.value ? (_openBlock(), _createBlock(MaskerLayer, {
        key: 1,
        onClose: _cache[1] || (_cache[1] = $event => relation.value = null)
      }, {
        default: _withCtx(() => [_createVNode(WORWORelationsEditCard, {
          relation: relation.value,
          onEditRelations: _cache[0] || (_cache[0] = $event => relation.value = null),
          onCreateRelations: createRelations,
          onUpdateRelations: updateRelations,
          onRemoveRelations: removeRelations
        }, null, 8, ["relation"])]),
        _: 1
      })) : _createCommentVNode("", true)]);
    };
  }

};